<template>
    <div id="help">
        <!--<div class="helpHeader">
            <h2 class="title main-container"><img @click="toIndex" src="../../assets/images/topBar1/logoIcon.png"/>帮助中心</h2>
        </div>-->
        <my-header></my-header>
        <div class="main-container tableWrap">
            <el-table
                :data="tableData"
                @current-change="handleCurrentChange"
                style="width: 100%">
                <el-table-column
                    prop="index"
                    label="序号"
                    width="180">
                </el-table-column>
                <el-table-column
                    label="文档">
                    <template slot-scope="scope">
                        <a class="words" href="javascript:;" @click="fileListHandleDownload(scope.row.lsAttachmentVO)" title="点击下载">
                           {{ scope.row.name}}
                        </a>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="date"
                    label="发布日期"
                    width="180">
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
    import MyHeader from '../common/Header.vue'
    export default {
        name: 'help',
        data() {
            return {
                tableData: [],
                currentRow: null,//当前选中行
                detail: {}//详细信息
            }
        },
        components: {
            MyHeader
        },
        created(){
            var path = this.$route.name;
            if(path == 'help'){
                this.$root.activeIndex = 'setting';
            }
            var _this = this;
            this.$root.postHttp('/v1/sArticle/public/getHelpCenter',{
                "articleType": 1,
                "pageFlag": 0,
//                "pageFlag": 1,
                "pageNumber": 0,
                "pageSize": 0
            },function(res){
                let resultsArr = res.data.data || [];
                resultsArr.length && resultsArr.forEach((item,index) => {
                    _this.tableData.push({
                        index: index+1,
                        name: item.articleTitle,
                        date: item.createDate,
                        id: item.id,
                        lsAttachmentVO: item.lsAttachmentVO || []//附件
                    })
                })
            })
        },
        methods: {
            toIndex() {
                this.$root.activeIndex = 'home';
                this.$router.push('/');
            },
            handleCurrentChange(val) {//处理选中某一行的事件；
                this.currentRow = val;
            },
            fileListHandleDownload(fileList) {
//                console.log(fileList, '下载')
                if(!fileList.length){
                    return;
                }
                let that = this;
                that.$confirm('确定下载该附件吗?',{
                    type:'warning',
                    callback:(action)=>{
                        if(action == 'confirm'){
                            fileList.forEach( (item) => {
                                that.$root.downloadFile({
                                    attachName: item.attachName,
                                    attachPath: item.attachPath
                                })
                            })

                        }
                    }
                });
            }
        }
    }
</script>
<style lang="scss">
    @import "../../assets/_var.scss";
    #help {
        position: relative;
        & .head-right {
            color: $--text-color-light;
            & .login {
                background: url('../../assets/images/topBar2/icon07.png') no-repeat 0 1px;
            }
            & .register {
                background: url('../../assets/images/topBar2/icon08.png') no-repeat 0 1px;
            }
            & .line {
                background: $--text-color-light;
            }
            & .help {
                background: url('../../assets/images/topBar2/icon05.png') no-repeat;
            }
            & .wechat {
                background: url('../../assets/images/topBar2/icon06.png') no-repeat;
            }
        }
        & .tableWrap {
           padding-top: 80px;
        }
        & .detail {
            margin-top: 30px;
            p {
                text-align: right;
            }
           .el-button {
               padding: 8px 22px;
            }
        }
        & .title {
            text-align: left;
            & img {
                width: 240px;
                height: 29px;
                margin-right: 20px;
                vertical-align: text-bottom;
                cursor: pointer;
            }
        }
        & table thead th {
            text-align: center;
        }
        & .words {
            color: #333;
            text-decoration: none;
        }
        & .words:hover {
            color: $--primary-color;
            text-decoration: underline;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/common/Help.vue